import React from "react";
import { buildUpsTrackingHref } from "@loomstateorg/shared-frontend/utils/upsTrackingUrl";

export interface UpsTrackingLinkProps {
    trackingId: string;
    className?: string;
}

const UpsTrackingLink = ({ trackingId, className }: UpsTrackingLinkProps) => {
    const id = trackingId.trim();

    if (!id) {
        return null;
    }

    return (
        <a
            href={buildUpsTrackingHref(id)}
            target="_blank"
            rel="noopener noreferrer"
            className={className}
            data-testid="ups-tracking-link"
        >
            {id}
        </a>
    );
};

export default UpsTrackingLink;
